import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ChatWidget } from "./components/ChatWidget";

// Pages
import HomePage from "./pages/HomePage";
import TripsPage from "./pages/TripsPage";
import TripDetailPage from "./pages/TripDetailPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import AdminPage from "./pages/AdminPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import ResourcesPage from "./pages/ResourcesPage";
import ResourceDetailPage from "./pages/ResourceDetailPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import CustomizeTripPage from "./pages/CustomizeTripPage";
import SoloAdventuresPage from "./pages/SoloAdventuresPage";
import GroupAdventuresPage from "./pages/GroupAdventuresPage";
import MemberDashboard from "./pages/MemberDashboard";
import PayPage from "./pages/PayPage";
import SplitPaymentPage from "./pages/SplitPaymentPage";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/trips" element={<TripsPage />} />
              <Route path="/trips/:slug" element={<TripDetailPage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/resources/:slug" element={<ResourceDetailPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/customize" element={<CustomizeTripPage />} />
              <Route path="/solo-adventures" element={<SoloAdventuresPage />} />
              <Route path="/group-adventures" element={<GroupAdventuresPage />} />
              <Route path="/member" element={<MemberDashboard />} />
              <Route path="/dashboard" element={<MemberDashboard />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />
              <Route path="/booking-success" element={<BookingSuccessPage />} />
              <Route path="/pay" element={<PayPage />} />
              <Route path="/pay/:bookingId/:paymentLinkId" element={<SplitPaymentPage />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
